////////////
//API IBGE//
////////////
const BASE_IBGE_URL = "https://brasilapi.com.br/api/ibge";

export const API_IBGE = {
  estados: `${BASE_IBGE_URL}/uf/v1`,
  cidades: `${BASE_IBGE_URL}/municipios/v1`,

  // Adicione outras URLs conforme necessário
};
